export default {
    name: 'leaf-diagnostics',
    serverName: '/api/v1/mordovia/',
    fieldPointsApi: '/api/v1/mordovia/field_info/'
};
